<template>
  <div class="overflow-auto height-500 column is-12 mgt-">
    <v-client-table :data=listeLignes :columns="columns" :options="options"
                    class="is-marginless vueTableSelectionFaces">
      <template slot="select" slot-scope="props">
        <b-checkbox v-model="props.row.select"
                    @input="selectItem(props.row)">
        </b-checkbox>
      </template>
      <template slot="ligneReseau.anneeSemaine" slot-scope="props">
        {{ formatAnneeSemaine(props.row.ligneReseau.anneeSemaine) }}
      </template>
      <template slot="dateDebut" slot-scope="props">
        {{ formatDate(props.row.dateDebut) }}
      </template>
      <template slot="dateFin" slot-scope="props">
        {{ formatDate(props.row.dateFin) }}
      </template>
      <template slot="ligneReseau.qteFacesPrevues" slot-scope="props">
        <div class="has-text-right">
          {{ props.row.ligneReseau.qteFacesPrevues }}
        </div>
      </template>
      <template slot="ligneReseau.qteFacesSouhaitees" slot-scope="props">
        <div class="has-text-right">
          {{ props.row.ligneReseau.qteFacesSouhaitees }}
        </div>
      </template>
      <template slot="facesSelectionneees" slot-scope="props">
        <div class="has-text-right">
          {{ getFacesSelected(props.row.ordre) }}
        </div>
      </template>
    </v-client-table>
  </div>
</template>

<script>

import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import { TYPE_COMMANDE, TYPE_FACTURE } from '@/configuration/devisConf';
import {
  BLOQUE,
} from '@/configuration/optionBlocage/optionBlocage';
import formatDate from '@/services/general/formatDate';
import { CATEGORIE_REGROUPEMENT } from '@/configuration/catalogue/produitConf';

export default {
  props: {
    listeLignes: {
      type: Array,
      required: true,
    },
    ligneSelect: {
      type: Object,
      required: true,
    },
    typeDcf: {
      type: String,
      required: true,
    },
  },
  computed: {
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          libelle: this.$t('detailDevis.popupDuplicate.tab.libelle'),
          dateDebut: this.$t('detailDevis.popupDuplicate.tab.dateDebut'),
          dateFin: this.$t('detailDevis.popupDuplicate.tab.dateFin'),
          'ligneReseau.anneeSemaine': this.$t('detailDevis.popupDuplicate.tab.anneeSemaine'),
          'ligneReseau.qteFacesPrevues': this.$t('detailDevis.popupDuplicate.tab.qteFacesPrevues'),
          'ligneReseau.qteFacesSouhaitees': this.$t('detailDevis.popupDuplicate.tab.qteFacesSouhaitees'),
          facesSelectionneees: this.$t('detailDevis.popupDuplicate.tab.facesSelectionneees'),
          select: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAllItems();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        filterable: false,
        texts: TEXTS,
        columnsClasses: {
          select: 'colonneSelected',
          libelle: 'min-width-300',
          dateDebut: 'min-width-130',
          dateFin: 'min-width-130',
        },
        sortable: ['libelle', 'dateDebut', 'dateFin', 'ligneReseau.anneeSemaine', 'ligneReseau.qteFacesPrevues', 'ligneReseau.qteFacesSouhaitees', 'facesSelectionneees'],
      };
    },
    iconSelectTotal() {
      if (this.allLigneSelected) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    columns() {
      const columns = ['select', 'libelle', 'dateDebut', 'dateFin', 'ligneReseau.qteFacesPrevues', 'ligneReseau.qteFacesSouhaitees', 'facesSelectionneees'];
      if (this.isSelectedForReseauTempo) {
        columns.splice(2, 0, 'ligneReseau.anneeSemaine');
      }
      return columns;
    },
    allLigneSelected() {
      return this.listeLignes.length === this.listeLignesSelected.length
        && this.listeLignes.length > 0;
    },
    listeLignesSelected() {
      return this.listeLignes.filter(ligne => ligne.select);
    },
    isSelectedForReseauTempo() {
      return this.ligneSelect.typeProduit === CATEGORIE_REGROUPEMENT;
    },
  },
  methods: {
    formatDate,
    formatAnneeSemaine(anneeSemaine) {
      const annee = ('' + anneeSemaine).substring(0, 4);
      const semaine = ('' + anneeSemaine).substring(4, 6);
      return 'S' + semaine + ' - ' + annee;
    },
    getFacesSelected(ordre) {
      const ligne = this.listeLignes.filter(l => l.ordre === ordre)[0];
      if ([TYPE_COMMANDE, TYPE_FACTURE].includes(this.typeDcf)
        || ligne.etatSouhaite === BLOQUE
        || ligne.etatObtenu === BLOQUE) {
        return ligne.ligneReseau.lignesCmdSelProduits.length;
      }
      return ligne.lignesCmdSelOptionProduit.length;
    },
    selectItem(item) {
      const ligneFind = this.listeLignes.find((l) => {
        return l.ordre === item.ordre;
      });
      if (ligneFind) ligneFind.select = !ligneFind.select;
    },
    selectAllItems() {
      const select = !this.allLigneSelected;
      this.listeLignes.forEach((ligne) => {
        ligne.select = select;
      });
    },
  },
  mounted() {
    this.listeLignes.forEach(l => this.$set(l, 'select', false));
  },
};
</script>
